var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenPostIt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 210,
    viewBox: "0 0 199 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_218_113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 47.5,
    width: 116,
    height: 114,
    rx: 3.5,
    fill: "#BAD7F2",
    stroke: "#1B998B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 44.5,
    width: 113,
    height: 113,
    rx: 3.5,
    fill: "#BAD7F2",
    stroke: "#1B998B",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_218_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.945 188.882V100.001C163.945 97.24 166.183 95.0015 168.945 95.0015H178.945C181.706 95.0015 183.945 97.24 183.945 100.001V188.882C183.945 189.619 183.786 190.344 183.434 190.992C182.11 193.425 178.362 199.501 173.945 199.501C169.528 199.501 165.78 193.425 164.456 190.992C164.103 190.344 163.945 189.619 163.945 188.882Z",
    fill: "#F8F4A6",
    stroke: "#1B998B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.944 97.5H183.944H186.453C187.276 97.5 187.944 96.8321 187.944 96.0083L187.944 96.0012C187.946 95.8534 188.596 24.4947 187.944 18C187.292 11.4985 182.781 2 173.944 2C165.108 2 160.444 9.99854 159.444 18C158.597 24.7852 159.187 77.2313 159.385 93.0183C159.417 95.5135 161.449 97.5 163.944 97.5Z",
    fill: "#1B998B",
    stroke: "#1B998B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.445 26.5015V26.5015C191.378 26.5015 192.945 28.0685 192.945 30.0015V80.5015",
    stroke: "#1B998B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.945,
    cy: 80.5015,
    r: 1.5,
    fill: "#1B998B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_218_113",
    x: 0,
    y: 43,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_218_113",
    x: 153.5,
    y: 0.5,
    width: 44.9447,
    height: 208.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_113",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenPostIt);
export default __webpack_public_path__ + "static/media/pen-post-it.813abf2ced54f8a6a84b24c543af6b90.svg";
export { ForwardRef as ReactComponent };